import dayjs from "dayjs";

export const seasonColumn = [
    {
        label: '赛季名称',
        prop: 'name'
    },
    {
        label: '赛季天数',
        prop: 'seasonDayNum'
    },
    {
        width: '120',
        label: '赛季周期',
        prop: 'seasonCycle'
    },
    {
        width: '80',
        label: '状态',
        prop: 'status'
    },
    {
        label: '参加战队总数',
        prop: 'joinPkTeamNum'
    },
    {
        width: '120',
        label: '最后修改时间',
        prop: 'lastUpdateDate'
    },
    {
        width: '80',
        label: '操作者',
        prop: 'lastUpdateName'
    }
];

export const translationSeasonStatus = (start, end) => {
    const nowTime = dayjs().valueOf(),
        startTime = dayjs(start).valueOf(),
        endTime = dayjs(end).valueOf();
    if (nowTime > endTime) {
        return '已结束';
    } else if (startTime <= nowTime && nowTime <= endTime) {
        return '进行中';
    } else if (startTime > nowTime) {
        return '未开始';
    }
    return '';
}

export const teamStatusList = [
    {
        value: 'all',
        label: '全部'
    },
    {
        value: '1',
        label: '正常'
    },
    {
        value: '2',
        label: '已解散'
    }
];

export const teamColumn = [
    {
        label: '战队名称',
        prop: 'name'
    },
    {
        label: '队长名称',
        prop: 'captainName'
    },
    {
        label: '当前段位',
        prop: 'grade'
    },
    {
        label: '今日PK战队',
        prop: 'pkName'
    },
    {
        label: '胜利次数',
        prop: 'count'
    },
    {
        width: '120',
        label: '最后修改时间',
        prop: 'lastUpdateDate'
    },
    {
        width: '80',
        label: '状态',
        prop: 'status'
    },
];

export const playersColumn = [
    {
        label: '员工姓名',
        prop: 'saleName'
    },
    {
        label: '手机号',
        prop: 'mobile'
    },
    {
        label: '所属事业部',
        prop: 'companyName'
    },
];

export const translationDan = (number) => {
    switch (number) {
        case 1:
            return '青铜';
        case 2:
            return '白银';
        case 3:
            return '黄金';
        case 4:
            return '铂金';
        case 5:
            return '钻石';
        case 6:
            return '星耀';
        case 7:
            return '王者';
        default:
            return null;
    }
}

export const translationStatus = (number) => {
    switch (number) {
        case 1:
            return '正常';
        case 2:
            return '解散';
        default:
            return null;
    }
}

export const danList = [
    {
        value: 1,
        label: '青铜'
    },
    {
        value: 2,
        label: '白银'
    },
    {
        value: 3,
        label: '黄金'
    },
    {
        value: 4,
        label: '铂金'
    },
    {
        value: 5,
        label: '钻石'
    },
    {
        value: 6,
        label: '星耀'
    },
    {
        value: 7,
        label: '王者'
    },
];

export const historyPkColumn = [
    {
        width: '130',
        label: '日期',
        prop: 'thatDate'
    },
    {
        label: '今日本队段位',
        prop: 'grade'
    },
    {
        width: 120,
        label: 'PK战队名称/段位',
        prop: 'seasonTeamBNameAndGrade'
    },
    {
        label: '是否胜利',
        prop: 'isVictory'
    },
    {
        label: '战队奖金',
        prop: 'teamAward'
    },
    {
        label: '本队销售业绩',
        prop: 'seasonTeamAAchievement'
    },
    {
        width: '120',
        label: 'PK战队销售业绩',
        prop: 'seasonTeamBAchievement'
    },
    {
        label: 'MVP人员',
        prop: 'mvpName'
    },
    {
        label: 'MVP奖金',
        prop: 'personAward'
    },
];